export default "https://assets.egbcdn.net/assets/packs/_/images/svg_icons/app-bet-types-1d6818b14cb830bd76b549239da2e2ba.svg";